module.exports = __webpack_public_path__ + "static/media/banner-gold@2x.90821bbe.jpg";